var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"rating-bar"},[_c('span',{staticClass:"rating-bar__fill",style:(_vm.fillStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }